

/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import * as api from './api/axios.config' 
import cookie from 'vux/src/tools/cookie/index.js'
import dateFormat from 'vux/src/tools/date/format.js'
import Icon from 'vux/src/components/icon/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import Meta from 'vue-meta'
import md5 from 'js-md5' 
import 'vue2-animate/dist/vue2-animate.min.css'
import sa from 'cl_sensorsdata'
import * as filters from './common/filter' 

Vue.prototype.$http = api
Vue.prototype.$cookie = cookie
Vue.prototype.$dateFormat = dateFormat
Vue.prototype.$md5 = md5
Object.defineProperty(Vue.prototype, '$sa', {value: sa})
sa.init({
server_url: location.origin === 'https://u.orangevip.com' ? 'https://trace.orangevip.com/g.gif' : 'https://t-trace.orangevip.com/g.gif',
is_single_page: true,
show_log: true,
heatmap: {}
})
Vue.component('icon', Icon)
Vue.use(Meta)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin, {time: 2000, position: 'middle'})
Object.keys(filters).forEach((key) => {
Vue.filter(key, filters[key])
})

sa.registerPage({
PlatformType: location.pathname.indexOf('/h5')> -1 ? 'H5' : 'PC'
})

router.beforeEach((to, from, next) => {
Vue.$vux.loading.show({
text: '加载中...'
})
if (navigator.userAgent.match(
/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
if (/^\/pc/.test(to.fullPath)) {
next({
path: '/h5' + to.fullPath.slice(3),
replace: true
})
} else {
next()
}
} else {
if (/^\/h5/.test(to.fullPath)) {
next({
path: '/pc' + to.fullPath.slice(3),
replace: true
})
} else {
next()
}
}
})
router.afterEach((to, from) => {
Vue.$vux.loading.hide()
sa.registerPage({
PlatformType: to.path.indexOf('/h5')> -1 ? 'H5' : 'PC'
})
sa.track('$pageview',{
'$referrer' : location.origin + from.fullPath,
'$referrer_host': location.origin,
'$url': location.origin + to.fullPath,
'$url_path': to.path,
'$title': to.meta.title
})
})
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: {App},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js